<section>
  <header>
    <h2>Model Confidence</h2>
    <div class="controls">
      <img src="/assets/img/mobile/mb-arrow-{{ expanded() ? 'down' : 'up' }}.svg" alt="arrow up"
        (click)="toggleBottomsheetHeight()" />
      <!-- <img
        style="margin-left: 12px;"
        src="/assets/img/mobile/mb-close.svg"
        alt="close icon"
        (click)="closeBottomSheet()"
      /> -->
    </div>
  </header>
  <div style="padding: 12px;">
    <div class="structure-overview" style="display: flex; flex-direction: column;">
      <div class="info">
        <p class="info__title">Average pLDDT</p>
        <p class="info__content">
          {{ averageplddtDisplay }}
        </p>
      </div>
      <div class="info">
        <p class="info__title">pLDDT distribution</p>
        <article style="display:flex; flex-direction: row;">
          <div>
            <div class="plddtlegends">
              <span class="legendColor" style="background-color: #0053d6;">&nbsp;</span>
              {{ formatPercentage(plddtData?.fractionPlddtVeryHigh) }}% Very high
            </div>
            <div class="plddtlegends">
              <span class="legendColor" style="background-color: #65cbf3;">&nbsp;</span>
              {{ formatPercentage(plddtData?.fractionPlddtConfident) }}% High
            </div>
            <div class="plddtlegends">
              <span class="legendColor" style="background-color: #ffdb13;">&nbsp;</span>
              {{ formatPercentage(plddtData?.fractionPlddtLow) }}% Low
            </div>
            <div class="plddtlegends">
              <span class="legendColor" style="background-color: #ff7d45;">&nbsp;</span>
              {{ formatPercentage(plddtData?.fractionPlddtVeryLow) }}% Very low
            </div>
          </div>
        </article>
      </div>
      <div class="legendsmobile">
        <linear-legends type="plddt"></linear-legends>
      </div>
      <div class="legendstext">
        <span>pLDDT is a per-residue measure of local confidence <br />
          <a (click)="gaService.eventEmitter(
                'link_visit',
                'home_href_click',
                'click',
                'learn more mobile',
                '')" href="./faq/#faq-12" target="_blank" class="licenseLink" target="_blank">
            Learn more...
          </a></span>
      </div>
    </div>
  </div>
</section>